export var IdTooltipAdjust;
(function (IdTooltipAdjust) {
    IdTooltipAdjust[IdTooltipAdjust["Small"] = 10] = "Small";
    IdTooltipAdjust[IdTooltipAdjust["SmallMedium"] = 12.5] = "SmallMedium";
    IdTooltipAdjust[IdTooltipAdjust["Medium"] = 15] = "Medium";
    IdTooltipAdjust[IdTooltipAdjust["Large"] = 20] = "Large";
    IdTooltipAdjust[IdTooltipAdjust["XLarge"] = 25] = "XLarge";
})(IdTooltipAdjust || (IdTooltipAdjust = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdTooltipAdjust.ts
// module id = 97
// module chunks = 3